import { gql } from '@apollo/client';
export const StatPermissionsForm = gql `
    query StatPermissionsForm($siteSetId: SiteSetId!, $formId: CustomRegistrationFormId!) {
        attendance {
            management {
                customRegistrationForm {
                    byFormId(siteSetId: $siteSetId, customRegistrationFormId: $formId) {
                        canView
                        canEdit
                        canDelete
                        canDownloadResponses
                        canDuplicate
                        canEditName
                        canEditSuccessMessage
                        canPublish
                        canUnpublish
                        canShare
                        canCreate
                        canCreateFollowUpForm
                        canToggleNotifications
                        canToggleConfirmationEmail
                        canManageSubmissionKeys
                        canSendEmails
                        canViewResponses
                        canSetFeeAmount
                        canViewFeeSection
                    }
                }
            }
        }
    }
`;
